<div style="min-height: 254px" *ngIf="salaryForm ">
  <form [formGroup]="salaryForm" (ngSubmit)="submit()">
    <div class="form">
      <div class="input-box">
      <span class="p-float-label">
        <input [style]="{width: '100%'}" [ngClass]="{'ng-dirty': salaryForm.get('company')?.touched}"
               id="company"
               type="text" pInputText formControlName="company"/>
        <label htmlFor="company">Company*</label>
      </span>
        <small
          id="company-help"
          class="p-error"
          *ngIf="salaryForm.get('company')?.touched && salaryForm.get('company')?.hasError('required')">
          The company is required.
        </small>
      </div>
      <div class="input-box">
      <span class="p-float-label">
        <input [style]="{width: '100%'}" [ngClass]="{'ng-dirty': salaryForm.get('amount')?.touched}"
               id="amount"
               type="number" pInputText formControlName="amount"/>
        <label htmlFor="amount">Amount*</label>
      </span>
        <small
          id="amount-help"
          class="p-error"
          *ngIf="salaryForm.get('amount')?.touched && salaryForm.get('amount')?.hasError('required')">
          The amount is required.
        </small>
      </div>
      <div class="input-box">
        <span class="p-float-label">
          <input [style]="{width: '100%'}" [ngClass]="{'ng-dirty': salaryForm.get('percent')?.touched}"
                 id="percent"
                 type="number" pInputText formControlName="percent"/>
          <label htmlFor="percent">Percent*</label>
        </span>

        <small
          id="percent-help"
          class="p-error"
          *ngIf="salaryForm.get('percent')?.touched && salaryForm.get('percent')?.hasError('required')">
          The percent is required.
        </small>
      </div>
      <div class="input-box">
      <span class="p-float-label">
                <div style="min-width: 100%;" [ngClass]="{'ng-dirty': salaryForm.get('from')?.touched}">

                  <span [ngClass]="{'invalid-label': salaryForm.get('from')?.touched && !salaryForm.get('from')?.valid}"
                        htmlFor="to" id="fromLabel">From*</span>

                        <p-calendar
                          [style]="{width: '100%'}"
                          id="from"
                          [showIcon]="true"
                          formControlName="from"
                          [appendTo]="'body'"
                          placeholder="From"
                          ariaLabelledBy="fromLabel"
                        ></p-calendar>
                </div>
      </span>
        <small
          id="from-help"
          class="p-error"
          *ngIf="salaryForm.get('from')?.touched && salaryForm.get('from')?.hasError('required')">
          The field is required.
        </small>
      </div>
      <div class="input-box">
      <span class="p-float-label">
       <div style="min-width: 100%;" [ngClass]="{'ng-dirty': salaryForm.get('to')?.touched}">
         <span [ngClass]="{'invalid-label': salaryForm.get('to')?.touched && !salaryForm.get('to')?.valid}" htmlFor="to"
               id="toLabel">To*</span>
            <p-calendar
              [style]="{width: '100%'}"
              id="to"
              [showIcon]="true"
              [appendTo]="'body'"
              formControlName="to"
              placeholder="To"
              ariaLabelledBy="toLabel"
            ></p-calendar>
       </div>
      </span>
        <small
          id="to-help"
          class="p-error"
          *ngIf="salaryForm.get('to')?.touched">
          <ng-container *ngIf="salaryForm.get('to')?.hasError('required')">The field is required.</ng-container>
          <ng-container *ngIf="salaryForm.get('to')?.hasError('dateRangeError')">"From" must be less than "To".
          </ng-container>
        </small>
      </div>

      <div class="input-box buttons">
        <p-button [style]="{width: '120px'}" [disabled]="salaryForm.invalid || salaryForm.disabled" type="submit"
                  label="Save"></p-button>
      </div>
    </div>
  </form>
</div>

